module.exports = __webpack_public_path__ + "img/crm-fr-ca.6bed70f7.jpg";